/**
 * Normalise a page's `pageMetadata.linkedDataSchema` into the single JSON-LD object emitted in the
 * document head (NGF-6550). Single source of truth shared by RR7 atlas (`routes/$/meta.ts`) and
 * atlas-astro (`ChromeLayout.astro`) so both emit byte-equivalent structured data.
 *
 * - Array → one `@graph` object: `@context` taken from the first element, `@graph` = the array with
 *   each element's own `@context` stripped (Google collapses per-node contexts into the top-level one).
 * - Single object → passed through unchanged.
 * - Falsy (undefined/null/empty string) → `undefined`, so callers skip emitting the script.
 *
 * The empty-array edge yields `{ '@context': undefined, '@graph': [] }` (truthy → still emitted) —
 * matching the original RR7 behaviour rather than special-casing it.
 */
export function buildLinkedDataSchema(raw: unknown): Record<string, unknown> | undefined {
  if (!raw) {
    return undefined;
  }

  if (Array.isArray(raw)) {
    return {
      '@context': (raw[0] as Record<string, unknown>)?.['@context'],
      '@graph': raw.map(item => {
        const { '@context': _ctx, ...rest } = item as Record<string, unknown>;
        return rest;
      }),
    };
  }

  return raw as Record<string, unknown>;
}
